import { gql, TypedDocumentNode } from '@common/hooks';
import {
  ReinviteSupplierToSignupMutationCgResponse,
  ReinviteSupplierToSignupMutationVariables,
} from '@common/graphql/schema';

export const REINVITE_SUPPLIER_TO_SIGNUP_MUTATION: TypedDocumentNode<
  ReinviteSupplierToSignupMutationCgResponse,
  ReinviteSupplierToSignupMutationVariables
> = gql`
  mutation ReinviteSupplierToSignup(
    $invitationId: ID!
    $input: ReinviteSupplierToSignupInput!
  ) {
    reinviteSupplierToSignup(invitationId: $invitationId, input: $input) {
      success
    }
  }
`;
